import React, { PureComponent } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';

// components
import Main from './pages/Main';

class App extends PureComponent {
  render() {
    return (
      <div className="pusher">
        <Switch>
          <Route path="/" component={Main} />
        </Switch>
      </div>
    );
  }
}

export default withRouter(App);




// WEBPACK FOOTER //
// ./src/App.js